import React from "react";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { AppProvider, SoundProvider } from "./context";
import Layout from "./component/Layout/Layout";
import useLocalStorage from "hook/useLocalStorage";
import useHostGameStatus from "./hook/useHostGameStatus";
import useHostRoomLaunch from "./hook/useHostRoomLaunch";
import useHostAudioMute from "./hook/useHostAudioMute";
import HostConfig from "./integrations/host/HostConfig";
import preloadNavigationAssets from "./assets/preload";
import Home from "./scene/Home";
import Lobby from "./scene/Lobby";
import Room from "./scene/Room";
import Leaderboard from "./scene/Leaderboard";
import NotFound from "./scene/NotFound";

function AppContent() {
    const [storedVolume, ] = useLocalStorage("LASTDOTCARDS.VOLUME");
    const volume = storedVolume ? parseFloat(storedVolume) : 0.2;
    const audioMuted = useHostAudioMute();
    useHostGameStatus();
    useHostRoomLaunch();

    React.useEffect(() => {
        void preloadNavigationAssets();
    }, []);

    return (
        <SoundProvider muted={audioMuted} volume={volume}>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/lobby/:lobbyId" element={<Lobby />} />
                    <Route path="/room/:roomId" element={<Room />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </SoundProvider>
    );
}

function App() {
    const Router = HostConfig.host === "crazygames" ? HashRouter : BrowserRouter;

    return (
        <Router>
            <AppProvider>
                <AppContent />
            </AppProvider>
        </Router>
    );
}

export default App;
